exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".add-space+.add-space,.add-space-top{margin-top:1rem!important}", ""]);

// exports
